import React from 'react'
import type { ButtonVariant } from 'react-bootstrap/types'
import { isBlankHtml } from '@ztechapps/common.utils'
import { BusyButton } from '@ztechapps/webui.button'
import { useError } from '@ztechapps/common.hook'

export type FormalizeButtonProps = {
  message: string
  isFormalizing: boolean
  onFormalize: (content: string) => Promise<string>
  onFormalized: (text: string) => void
  /** Unset keeps today's default look; the inbox toolbar end slot passes "link" for chromeless chrome. */
  variant?: ButtonVariant
  disabled?: boolean
}

export const FormalizeButton = ({
  message,
  isFormalizing,
  onFormalize,
  onFormalized,
  variant,
  disabled,
}: FormalizeButtonProps) => {
  const { onError } = useError()

  const handleFormalize = async () => {
    try {
      const formalizedText = await onFormalize(message)

      if (formalizedText) {
        onFormalized(formalizedText)
      }
    } catch (err) {
      onError(err instanceof Error ? err : new Error(String(err)))
    }
  }

  return (
    <BusyButton
      icon="wand-magic-sparkles"
      title="Formalize with AI"
      aria-label="Formalize with AI"
      isBusy={isFormalizing}
      busyText=" "
      disabled={disabled || isBlankHtml(message)}
      onClick={handleFormalize}
      variant={variant}
    />
  )
}
